'use strict';
var parent = require('../../actual/instance/reverse');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/full/instance/reverse.js
// module id = 625
// module chunks = 13